var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',{staticClass:"mx-auto overflow-hidden rounded-0",attrs:{"color":"#F2F4F4","height":"100vh"}},[_c('nav-bar-client'),_c('v-subheader',[_vm._v(" Mis Clientes")]),_c('scroll-client'),_c('new-client')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }